export const VideoDatas = [
    {
      id:1,
      title:"Black Coffee, Sun EL, Caiiro, Africanism , | Afro House Mix",
      url:"https://www.youtube.com/watch?v=weoG9kAYdoY",
      description:" You will face many defeats in life  but never let yourself be defeated Here is a Afro House Mix for Marco fans  Please subscribe to keep postedAll Copyrights go to their respective owners ",
      Views:"1,008,978 views",
      thambnails:"https://i3.ytimg.com/vi/weoG9kAYdoY/maxresdefault.jpg",
      Likes:"10k",
      chaineName:"Marco Milano",
      DateUpload:"Apr 12, 2021",
      chaineAvatar:"https://yt3.ggpht.com/nb0yaX-cKrViJhL5IrUmgqYalAA0Av5ME761-9SpS-Fx1HH8rGT8PSiVG4gGvazx2Tg2rOeu=s88-c-k-c0x00ffffff-no-nd-rj"
  },
  {
      id:2,
      title:"Tailwind CSS Crash Course",
      url:"https://www.youtube.com/watch?v=UBOj6rqRUME",
      description:"In this video we will look at the TailwindCSS utility framework including what it is, setup and creating custom components with utilities",
      Views:"514,072 views",
      thambnails:"https://i3.ytimg.com/vi/UBOj6rqRUME/maxresdefault.jpg",
      Likes:"11k",
      chaineName:"Traversy MEdia",
      DateUpload:"Jul 24, 2019",
      chaineAvatar:"https://yt3.ggpht.com/ytc/AMLnZu-fB-c8gczS81r-VBWgzndcSZgd1zGA2QcYfACHMg=s88-c-k-c0x00ffffff-no-rj"
  },
  {
      id:3,
      "title":"React JS Crash Course",
      "url":"https://www.youtube.com/watch?v=w7ejDZ8SWv8",
      "Views":"2,647,566 views",
      "description":"Get started with React in this crash course. We will be building a task tracker app and look at components, props, state, hooks, working with an API and more.",
      "thambnails":"https://i3.ytimg.com/vi/w7ejDZ8SWv8/maxresdefault.jpg",
      "Likes":"53k",
      "chaineName":"Traversy MEdia",
      "DateUpload":"Jan 18, 2021 ",
      "chaineAvatar":"https://yt3.ggpht.com/ytc/AMLnZu-fB-c8gczS81r-VBWgzndcSZgd1zGA2QcYfACHMg=s88-c-k-c0x00ffffff-no-rj"
  },
  {
      id:4,
      "title":"Redux Tutorial - Learn Redux from Scratch",
      "url":"https://www.youtube.com/watch?v=poQXNp9ItL4",
      "Views":"816,897 views",
      "description":"Redux tutorial - Learn redux from scratch Get the full Redux course: https://codewithmosh.com/p/ultimate-r...Subscribe for more tutorials like this: https://goo.gl/6PYaGF",
      "thambnails":"https://i3.ytimg.com/vi/poQXNp9ItL4/maxresdefault.jpg",
      "Likes":"18k",
      "chaineName":"Programming with Mosh",
      "DateUpload":"Premiered Apr 20, 2020  ",
      "chaineAvatar":"https://yt3.ggpht.com/tBEPr-zTNXEeae7VZKSZYfiy6azzs9OHowq5ZvogJeHoVtKtEw2PXSwzMBKVR7W0MI7gyND8=s88-c-k-c0x00ffffff-no-rj"
  },
  {
      id:5,
      "title":"Bootstrap CSS Framework - Full Course for Beginners",
      "url":"https://www.youtube.com/watch?v=-qfEOE4vtxE",
      "Views":"489,791 views ",
      "description":"Learn Bootstrap 5 in this full course for beginners. Bootstrap is the most popular CSS framework. It allows web developers to quickly design and customize responsive mobile-first sites.",
      "thambnails":"https://i3.ytimg.com/vi/-qfEOE4vtxE/maxresdefault.jpg",
      "Likes":"11k",
      "chaineName":"freeCodeCamp.org",
      "DateUpload":"Dec 7, 2021",
      "chaineAvatar":"https://yt3.ggpht.com/ytc/AMLnZu9UWrGceKWaqm8AF89vuxrEt8MO3E59qOoQ785Lew=s88-c-k-c0x00ffffff-no-rj"
  },
  {
      id:6,
      "title":"Kotlin in 100 Seconds",
      "url":"https://www.youtube.com/watch?v=xT8oP0wy-A0",
      "Views":"579,691 views",
      "description":"  Kotlin is a programming language designed as a modern alternative to Java. It supports functional patterns, coroutines, multi-platform compilation, and is now the recommended language for Android mobile development. ",
      "thambnails":"https://i3.ytimg.com/vi/xT8oP0wy-A0/maxresdefault.jpg",
      "Likes":"31k",
      "chaineName":"Fireship",
      "DateUpload":" Nov 5, 2021",
      "chaineAvatar":"https://yt3.ggpht.com/ytc/AMLnZu80d66aj0mK3KEyMfpdGFyrVWdV5tfezE17IwRkhw=s88-c-k-c0x00ffffff-no-rj"
  },
  {
      id:7,
      "title":"YASUO MONTAGE 2022 - PERFECT",
      "url":"https://www.youtube.com/watch?v=WILzaF7UNNY",
      "Views":"13,630 views",
      "description":" ",
      "thambnails":"https://i3.ytimg.com/vi/WILzaF7UNNY/maxresdefault.jpg",
      "Likes":"274",
      "chaineName":"LOL TIME",
      "DateUpload":"Sep 1, 2022",
      "chaineAvatar":"https://yt3.ggpht.com/ytc/AMLnZu-yxy3o8El9sHBfJRwtblc1BrMcrV_HZHJqnFNH=s88-c-k-c0x00ffffff-no-rj"
  }, {
      id:8,
      "title":"Apple Event — September 7",
      "url":"https://www.youtube.com/watch?v=ux6zXguiqxM",
      "Views":"22,497,806 views",
      "description":"Watch the special Apple Event to learn about iPhone 14, iPhone 14 Pro, Apple Fitness+, Apple Watch Ultra Apple Watch Series 8 AirPods Pro, and more. ",
      "thambnails":"https://i3.ytimg.com/vi/ux6zXguiqxM/maxresdefault.jpg",
      "Likes":"761k",
      "chaineName":"Apple",
      "DateUpload":"Streamed live 18 hours ago",
      "chaineAvatar":"https://yt3.ggpht.com/ytc/AMLnZu-WCPytY25vnp0GFcCrTIQ0VAgIs5oqKK2zNgDl5A=s88-c-k-c0x00ffffff-no-rj"
      
  }
]
export const ShortDatas = [
  {
    "id":1,
    "url":"https://www.youtube.com/shorts/wRyu2Maoiuc",
    "title":"This guy to get a jacket",
    "Views":"200k views"
},
{
    "id":2,
    "url":"https://www.youtube.com/shorts/cMtYwPcwcBU",
    "title":"Don't learn web dev this way",
    "Views":"243k views"
},
{
    "id":3,
    "url":"https://www.youtube.com/shorts/fgJNxql3Cy0",
    "title":"if you sleep near your pc ?",
    "Views":"3.1M views"
},
{
    "id":4,
    "url":"https://www.youtube.com/shorts/A93TWmeIeJo",
    "title":"Consditional Display in HTML",
    "Views":"97K views"
}
]
export const Notifications = [
    {
        "id": 1,
        "ChaineName" : "ZAK Official" ,  
        "VideoAvatar": "https://yt3.ggpht.com/vhIrATNClBe3VZ55k-yfiDUtX5tbKyd4L_-NldetkidwCjcIDYBpIytsnqDTJiqX2beARV5Ixw=s88-c-k-c0x00ffffff-no-rj",
        "VideoURL":"https://www.youtube.com/watch?v=k-VBUVz5jXM",
        "VideoTitle":"AFRO DEEP HOUSE MIX | black coffee | shimza | caiiro",
        "VideoDate":"7 hours",
        "VideoThambnail":"http://i3.ytimg.com/vi/k-VBUVz5jXM/hqdefault.jpg",

    },
    {
        "id": 2,
        "ChaineName" : "Traversy MEdia" ,
        "VideoAvatar": "https://yt3.ggpht.com/ytc/AMLnZu-fB-c8gczS81r-VBWgzndcSZgd1zGA2QcYfACHMg=s88-c-k-c0x00ffffff-no-rj",
        "VideoURL": "https://www.youtube.com/watch?v=UBOj6rqRUME",
        "VideoTitle":"Tailwind CSS Crash Course",
        "VideoDate":"1 Day",
        "VideoThambnail": "https://i3.ytimg.com/vi/UBOj6rqRUME/maxresdefault.jpg",

    },
    {
        "id": 3,
        "ChaineName" : "Programming with Mosh" ,
        "VideoAvatar":"https://yt3.ggpht.com/tBEPr-zTNXEeae7VZKSZYfiy6azzs9OHowq5ZvogJeHoVtKtEw2PXSwzMBKVR7W0MI7gyND8=s88-c-k-c0x00ffffff-no-rj",
        "VideoURL":"https://www.youtube.com/watch?v=poQXNp9ItL4",
        "VideoTitle":"Redux Tutorial - Learn Redux from Scratch",
        "VideoDate":"2 Days",
        "VideoThambnail":"https://i3.ytimg.com/vi/poQXNp9ItL4/maxresdefault.jpg",

    },
    {
        "id": 4,
        "ChaineName" : "freeCodeCamp.org" ,
        "VideoAvatar":"https://yt3.ggpht.com/ytc/AMLnZu9UWrGceKWaqm8AF89vuxrEt8MO3E59qOoQ785Lew=s88-c-k-c0x00ffffff-no-rj",
        "VideoURL":"https://www.youtube.com/watch?v=-qfEOE4vtxE",
        "VideoTitle":"Bootstrap CSS Framework - Full Course for Beginners",
        "VideoDate":"5 Days",
        "VideoThambnail":"https://i3.ytimg.com/vi/-qfEOE4vtxE/maxresdefault.jpg",

    },
    {
        "id": 5,
        "ChaineName" : "Apple" ,
        "VideoAvatar":"https://yt3.ggpht.com/ytc/AMLnZu-WCPytY25vnp0GFcCrTIQ0VAgIs5oqKK2zNgDl5A=s88-c-k-c0x00ffffff-no-rj",
        "VideoURL":"https://www.youtube.com/watch?v=ux6zXguiqxM",
        "VideoTitle":"Apple Event — September 7",
        "VideoDate":" 1 Week",
        "VideoThambnail":"https://i3.ytimg.com/vi/ux6zXguiqxM/maxresdefault.jpg",

    }
]
export const Languages = [   
    {
        id :1,
        value:  "Afrikaans",
    },
    {
        id: 2,
        value : "Azərbaycan",
    },
    {
        id: 3,
        value : "Indonesia"
    },
    {
        id:4,
        value: "Malaysia"
    },
    {
        id:5,
        value: "Bosanski"
    },
    {
        id:6,
        value: "Català"
    },
    {
        id:7,
        value: "Čeština"
    },
    {
        id : 8,
        value: "Dansk"
    },
    {
        id:9, 
        value : "Deutsch"
    },
    { 
        id: 10,
        value : "Eesti"
    },
    {
        id:11,
        value : "English_India"},
    {
        id:12,
        value : "English_UK"},
    {
        id:13,
        value : "English_US"},
    {
        id:14,
        value: "Español_ESP"
    },
    {
        id:15,
        value: "Español_Latinoamérica"
    },
    {
        id:16,
        value : "Español_US"
    },
    {
        id:17,
        value : "Euskara"
    },
    {
        id:18,
        value : "Filipino"
    },
    {   id :19,
        value : "Français"},
    { 
        id :20,
        value : "Arabe"},
  ]
  export const Countries = 
  [
    {"name": "Albania", "code": "AL"},
    {"name": "Åland Islands", "code": "AX"},
    {"name": "Algeria", "code": "DZ"},
    {"name": "American Samoa", "code": "AS"},
    {"name": "Andorra", "code": "AD"},
    {"name": "Angola", "code": "AO"},
    {"name": "Anguilla", "code": "AI"},
    {"name": "Antarctica", "code": "AQ"},
    {"name": "Antigua and Barbuda", "code": "AG"},
    {"name": "Argentina", "code": "AR"},
    {"name": "Armenia", "code": "AM"},
    {"name": "Aruba", "code": "AW"},
    {"name": "Australia", "code": "AU"},
    {"name": "Austria", "code": "AT"},
    {"name": "Azerbaijan", "code": "AZ"},
    {"name": "Bahamas (the)", "code": "BS"},
    {"name": "Bahrain", "code": "BH"},
    {"name": "Bangladesh", "code": "BD"},
    {"name": "Barbados", "code": "BB"},
    {"name": "Belarus", "code": "BY"},
    {"name": "Belgium", "code": "BE"},
    {"name": "Belize", "code": "BZ"},
    {"name": "Benin", "code": "BJ"},
    {"name": "Bermuda", "code": "BM"},
    {"name": "Bhutan", "code": "BT"},
    {"name": "Bolivia (Plurinational State of)", "code": "BO"},
    {"name": "Bonaire, Sint Eustatius and Saba", "code": "BQ"},
    {"name": "Bosnia and Herzegovina", "code": "BA"},
    {"name": "Botswana", "code": "BW"},
    {"name": "Bouvet Island", "code": "BV"},
    {"name": "Brazil", "code": "BR"},
    {"name": "British Indian Ocean Territory (the)", "code": "IO"},
    {"name": "Brunei Darussalam", "code": "BN"},
    {"name": "Bulgaria", "code": "BG"},
    {"name": "Burkina Faso", "code": "BF"},
    {"name": "Burundi", "code": "BI"},
    {"name": "Cabo Verde", "code": "CV"},
    {"name": "Cambodia", "code": "KH"},
    {"name": "Cameroon", "code": "CM"},
    {"name": "Canada", "code": "CA"},
    {"name": "Cayman Islands (the)", "code": "KY"},
    {"name": "Central African Republic (the)", "code": "CF"},
    {"name": "Chad", "code": "TD"},
    {"name": "Chile", "code": "CL"},
    {"name": "China", "code": "CN"},
    {"name": "Christmas Island", "code": "CX"},
    {"name": "Cocos (Keeling) Islands (the)", "code": "CC"},
    {"name": "Colombia", "code": "CO"},
    {"name": "Comoros (the)", "code": "KM"},
    {"name": "Congo (the Democratic Republic of the)", "code": "CD"},
    {"name": "Congo (the)", "code": "CG"},
    {"name": "Cook Islands (the)", "code": "CK"},
    {"name": "Costa Rica", "code": "CR"},
    {"name": "Croatia", "code": "HR"},
    {"name": "Cuba", "code": "CU"},
    {"name": "Curaçao", "code": "CW"},
    {"name": "Cyprus", "code": "CY"},
    {"name": "Czechia", "code": "CZ"},
    {"name": "Côte d'Ivoire", "code": "CI"},
    {"name": "Denmark", "code": "DK"},
    {"name": "Djibouti", "code": "DJ"},
    {"name": "Dominica", "code": "DM"},
    {"name": "Dominican Republic (the)", "code": "DO"},
    {"name": "Ecuador", "code": "EC"},
    {"name": "Egypt", "code": "EG"},
    {"name": "El Salvador", "code": "SV"},
    {"name": "Equatorial Guinea", "code": "GQ"},
    {"name": "Eritrea", "code": "ER"},
    {"name": "Estonia", "code": "EE"},
    {"name": "Eswatini", "code": "SZ"},
    {"name": "Ethiopia", "code": "ET"},
    {"name": "Falkland Islands (the) [Malvinas]", "code": "FK"},
    {"name": "Faroe Islands (the)", "code": "FO"},
    {"name": "Fiji", "code": "FJ"},
    {"name": "Finland", "code": "FI"},
    {"name": "France", "code": "FR"},
    {"name": "French Guiana", "code": "GF"},
    {"name": "French Polynesia", "code": "PF"},
    {"name": "French Southern Territories (the)", "code": "TF"},
    {"name": "Gabon", "code": "GA"},
    {"name": "Gambia (the)", "code": "GM"},
    {"name": "Georgia", "code": "GE"},
    {"name": "Germany", "code": "DE"},
    {"name": "Ghana", "code": "GH"},
    {"name": "Gibraltar", "code": "GI"},
    {"name": "Greece", "code": "GR"},
    {"name": "Greenland", "code": "GL"},
    {"name": "Grenada", "code": "GD"},
    {"name": "Guadeloupe", "code": "GP"},
    {"name": "Guam", "code": "GU"},
    {"name": "Guatemala", "code": "GT"},
    {"name": "Guernsey", "code": "GG"},
    {"name": "Guinea", "code": "GN"},
    {"name": "Guinea-Bissau", "code": "GW"},
    {"name": "Guyana", "code": "GY"},
    {"name": "Haiti", "code": "HT"},
    {"name": "Heard Island and McDonald Islands", "code": "HM"},
    {"name": "Holy See (the)", "code": "VA"},
    {"name": "Honduras", "code": "HN"},
    {"name": "Hong Kong", "code": "HK"},
    {"name": "Hungary", "code": "HU"},
    {"name": "Iceland", "code": "IS"},
    {"name": "India", "code": "IN"},
    {"name": "Indonesia", "code": "ID"},
    {"name": "Iran (Islamic Republic of)", "code": "IR"},
    {"name": "Iraq", "code": "IQ"},
    {"name": "Ireland", "code": "IE"},
    {"name": "Isle of Man", "code": "IM"},
    {"name": "Israel", "code": "IL"},
    {"name": "Italy", "code": "IT"},
    {"name": "Jamaica", "code": "JM"},
    {"name": "Japan", "code": "JP"},
    {"name": "Jersey", "code": "JE"},
    {"name": "Jordan", "code": "JO"},
    {"name": "Kazakhstan", "code": "KZ"},
    {"name": "Kenya", "code": "KE"},
    {"name": "Kiribati", "code": "KI"},
    {"name": "Korea (the Democratic People's Republic of)", "code": "KP"},
    {"name": "Korea (the Republic of)", "code": "KR"},
    {"name": "Kuwait", "code": "KW"},
    {"name": "Kyrgyzstan", "code": "KG"},
    {"name": "Lao People's Democratic Republic (the)", "code": "LA"},
    {"name": "Latvia", "code": "LV"},
    {"name": "Lebanon", "code": "LB"},
    {"name": "Lesotho", "code": "LS"},
    {"name": "Liberia", "code": "LR"},
    {"name": "Libya", "code": "LY"},
    {"name": "Liechtenstein", "code": "LI"},
    {"name": "Lithuania", "code": "LT"},
    {"name": "Luxembourg", "code": "LU"},
    {"name": "Macao", "code": "MO"},
    {"name": "Madagascar", "code": "MG"},
    {"name": "Malawi", "code": "MW"},
    {"name": "Malaysia", "code": "MY"},
    {"name": "Maldives", "code": "MV"},
    {"name": "Mali", "code": "ML"},
    {"name": "Malta", "code": "MT"},
    {"name": "Marshall Islands (the)", "code": "MH"},
    {"name": "Martinique", "code": "MQ"},
    {"name": "Mauritania", "code": "MR"},
    {"name": "Mauritius", "code": "MU"},
    {"name": "Mayotte", "code": "YT"},
    {"name": "Mexico", "code": "MX"},
    {"name": "Micronesia (Federated States of)", "code": "FM"},
    {"name": "Moldova (the Republic of)", "code": "MD"},
    {"name": "Monaco", "code": "MC"},
    {"name": "Mongolia", "code": "MN"},
    {"name": "Montenegro", "code": "ME"},
    {"name": "Montserrat", "code": "MS"},
    {"name": "Morocco", "code": "MA"},
    {"name": "Mozambique", "code": "MZ"},
    {"name": "Myanmar", "code": "MM"},
    {"name": "Namibia", "code": "NA"},
    {"name": "Nauru", "code": "NR"},
    {"name": "Nepal", "code": "NP"},
    {"name": "Netherlands (the)", "code": "NL"},
    {"name": "New Caledonia", "code": "NC"},
    {"name": "New Zealand", "code": "NZ"},
    {"name": "Nicaragua", "code": "NI"},
    {"name": "Niger (the)", "code": "NE"},
    {"name": "Nigeria", "code": "NG"},
    {"name": "Niue", "code": "NU"},
    {"name": "Norfolk Island", "code": "NF"},
    {"name": "Northern Mariana Islands (the)", "code": "MP"},
    {"name": "Norway", "code": "NO"},
    {"name": "Oman", "code": "OM"},
    {"name": "Pakistan", "code": "PK"},
    {"name": "Palau", "code": "PW"},
    {"name": "Palestine, State of", "code": "PS"},
    {"name": "Panama", "code": "PA"},
    {"name": "Papua New Guinea", "code": "PG"},
    {"name": "Paraguay", "code": "PY"},
    {"name": "Peru", "code": "PE"},
    {"name": "Philippines (the)", "code": "PH"},
    {"name": "Pitcairn", "code": "PN"},
    {"name": "Poland", "code": "PL"},
    {"name": "Portugal", "code": "PT"},
    {"name": "Puerto Rico", "code": "PR"},
    {"name": "Qatar", "code": "QA"},
    {"name": "Republic of North Macedonia", "code": "MK"},
    {"name": "Romania", "code": "RO"},
    {"name": "Russian Federation (the)", "code": "RU"},
    {"name": "Rwanda", "code": "RW"},
    {"name": "Réunion", "code": "RE"},
    {"name": "Saint Barthélemy", "code": "BL"},
    {"name": "Saint Helena, Ascension and Tristan da Cunha", "code": "SH"},
    {"name": "Saint Kitts and Nevis", "code": "KN"},
    {"name": "Saint Lucia", "code": "LC"},
    {"name": "Saint Martin (French part)", "code": "MF"},
    {"name": "Saint Pierre and Miquelon", "code": "PM"},
    {"name": "Saint Vincent and the Grenadines", "code": "VC"},
    {"name": "Samoa", "code": "WS"},
    {"name": "San Marino", "code": "SM"},
    {"name": "Sao Tome and Principe", "code": "ST"},
    {"name": "Saudi Arabia", "code": "SA"},
    {"name": "Senegal", "code": "SN"},
    {"name": "Serbia", "code": "RS"},
    {"name": "Seychelles", "code": "SC"},
    {"name": "Sierra Leone", "code": "SL"},
    {"name": "Singapore", "code": "SG"},
    {"name": "Sint Maarten (Dutch part)", "code": "SX"},
    {"name": "Slovakia", "code": "SK"},
    {"name": "Slovenia", "code": "SI"},
    {"name": "Solomon Islands", "code": "SB"},
    {"name": "Somalia", "code": "SO"},
    {"name": "South Africa", "code": "ZA"},
    {"name": "South Georgia and the South Sandwich Islands", "code": "GS"},
    {"name": "South Sudan", "code": "SS"},
    {"name": "Spain", "code": "ES"},
    {"name": "Sri Lanka", "code": "LK"},
    {"name": "Sudan (the)", "code": "SD"},
    {"name": "Suriname", "code": "SR"},
    {"name": "Svalbard and Jan Mayen", "code": "SJ"},
    {"name": "Sweden", "code": "SE"},
    {"name": "Switzerland", "code": "CH"},
    {"name": "Syrian Arab Republic", "code": "SY"},
    {"name": "Taiwan (Province of China)", "code": "TW"},
    {"name": "Tajikistan", "code": "TJ"},
    {"name": "Tanzania, United Republic of", "code": "TZ"},
    {"name": "Thailand", "code": "TH"},
    {"name": "Timor-Leste", "code": "TL"},
    {"name": "Togo", "code": "TG"},
    {"name": "Tokelau", "code": "TK"},
    {"name": "Tonga", "code": "TO"},
    {"name": "Trinidad and Tobago", "code": "TT"},
    {"name": "Tunisia", "code": "TN"},
    {"name": "Turkey", "code": "TR"},
    {"name": "Turkmenistan", "code": "TM"},
    {"name": "Turks and Caicos Islands (the)", "code": "TC"},
    {"name": "Tuvalu", "code": "TV"},
    {"name": "Uganda", "code": "UG"},
    {"name": "Ukraine", "code": "UA"},
    {"name": "United Arab Emirates (the)", "code": "AE"},
    {"name": "United Kingdom of Great Britain and Northern Ireland (the)", "code": "GB"},
    {"name": "United States Minor Outlying Islands (the)", "code": "UM"},
    {"name": "United States of America (the)", "code": "US"},
    {"name": "Uruguay", "code": "UY"},
    {"name": "Uzbekistan", "code": "UZ"},
    {"name": "Vanuatu", "code": "VU"},
    {"name": "Venezuela (Bolivarian Republic of)", "code": "VE"},
    {"name": "Viet Nam", "code": "VN"},
    {"name": "Virgin Islands (British)", "code": "VG"},
    {"name": "Virgin Islands (U.S.)", "code": "VI"},
    {"name": "Wallis and Futuna", "code": "WF"},
    {"name": "Western Sahara", "code": "EH"},
    {"name": "Yemen", "code": "YE"},
    {"name": "Zambia", "code": "ZM"},
    {"name": "Zimbabwe", "code": "ZW"}
  ]